import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import TopBanner from "./components/banner/topBanner.jsx";
import TopBlocks from "./components/blocks/topBlocks.jsx";
import StekBlock from "./components/blocks/stekBlock.jsx";
import TextBlock from "./components/blocks/textBlock.jsx";
import CommonBlock from "./components/blocks/commonBlock.jsx";
import HomePage from "./pages/Home";
import WebDevelopment from "./pages/Web";
import Mobile from "./pages/Mobile";
import Logistic from "./pages/Logistic";
import Sklad from "./pages/Sklad";
import Proggram from "./pages/Proggram";
import Cases from "./pages/Cases";
import Team from "./pages/Team";
import Contacts from "./pages/Contacts";
import Brif from "./pages/Brif";
import Politica from "./pages/Politica.js";
import Soglashenie from "./pages/Soglashenie.js";
import "./assets/styles/fonts.css";
import "./assets/styles/icons.css";
import TopBox from "./components/blocks/topBox.jsx";
import { Banners, textBlocks, topBlocks } from "./components/data.js";

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Header />
        <main>
          <Routes>
            {/* Главная страница */}
            <Route
              path="/"
              element={
                <>
                  <TopBanner title={Banners[0].title} text={Banners[0].text} />
                  <div className="container">
                    <div className="topBlocks">
                      {topBlocks.map((topBoxItem) => (
                        <TopBox className="topBox" topBoxItem={topBoxItem} />
                      ))}
                    </div>
                  </div>
                  <div className="container">
                    <TextBlock
                      title={textBlocks[0].title}
                      text={textBlocks[0].text}
                    />
                  </div>
                  <StekBlock />
                  <CommonBlock />
                </>
              }
            />

            {/* Страницы */}
            <Route path="/web-development" element={<WebDevelopment />} />
            <Route path="/mobile" element={<Mobile />} />
            <Route path="/logistic" element={<Logistic />} />
            <Route path="/sklad" element={<Sklad />} />
            <Route path="/proggram" element={<Proggram />} />
            <Route path="/cases" element={<Cases />} />
            <Route path="/team" element={<Team />} />
            <Route path="/contacts" element={<Contacts />} />
            <Route path="/brif" element={<Brif />} />
            <Route path="/politica" element={<Politica />} />
            <Route path="/soglashenie" element={<Soglashenie />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
